<div class="vendor-shell relative flex min-h-screen">
    <!-- Sidebar for Desktop -->
    <div
        class="sticky top-0 left-0 z-50 hidden h-screen shrink-0 md:block"
        [class]="isSidebarCollapsed() ? 'w-[4.5rem]' : 'w-64'"
    >
        <app-sidebar-vendor
            [isCollapsed]="isSidebarCollapsed()"
            [logoSrc]="logoSrc()"
            [logoAlt]="logoAlt()"
            [companyName]="effectiveCompanyName()"
            [navigationGroups]="navigationGroups()"
        />
    </div>

    <!-- Sidebar Drawer for Mobile -->
    <div
        class="fixed inset-0 z-50 transition-opacity duration-300 md:hidden"
        [ngStyle]="{
            'background-color': isMobileSidebarOpen()
                ? 'rgba(0, 0, 0, 0.35)'
                : 'transparent',
            'pointer-events': isMobileSidebarOpen() ? 'auto' : 'none',
            opacity: isMobileSidebarOpen() ? '1' : '0',
        }"
        (click)="closeMobileSidebar()"
    >
        <div
            class="absolute top-0 left-0 w-64 shadow-xl transition-transform duration-300 ease-out"
            [ngClass]="{
                '-translate-x-full': !isMobileSidebarOpen(),
                'translate-x-0': isMobileSidebarOpen(),
            }"
            (click)="$event.stopPropagation()"
        >
            <app-sidebar-vendor
                [isCollapsed]="false"
                [logoSrc]="logoSrc()"
                [logoAlt]="logoAlt()"
                [companyName]="effectiveCompanyName()"
                [navigationGroups]="navigationGroups()"
            />
        </div>
    </div>

    <!-- Main Content Area -->
    <section class="flex min-w-0 flex-1 flex-col">
        <app-header-vendor
            [userName]="userName() || user.userName() || ''"
            (sidebarToggle)="toggleSidebar()"
        />

        <main class="vendor-main flex-1">
            <ng-content></ng-content>
        </main>
    </section>
</div>
